import { render, staticRenderFns } from "./ToeflComponentScore.vue?vue&type=template&id=9aa4b3b4&"
import script from "./ToeflComponentScore.vue?vue&type=script&lang=js&"
export * from "./ToeflComponentScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports